<template>
    <div>
        <!-- checkbox -->
        <div class="form-check">
            <input class="form-check-input" type="checkbox" :checked="config.push_all_nodes_to_oltp" id="pushAllNodesToOltp" @click="setPushAllNodesToOltp(); updateConfig()"
                :disabled="!fieldInfo?.push_all_nodes_to_oltp?.editable">
            <label class="form-check-label" for="pushAllNodesToOltp">
                Push All Nodes to OLTP
                <span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.push_all_nodes_to_oltp?.tooltip"
                    data-bs-toggle="tooltip" data-bs-placement="right"></span>
            </label>
        </div>
        <div class="form-check mt-1">
            <input class="form-check-input" type="checkbox" :checked="config.push_all_nodes_to_oltp_rev" id="pushAllNodesToOltpRev" @click="setPushAllNodesToOltpRev(); updateConfig()"
                :disabled="!fieldInfo?.push_all_nodes_to_oltp_rev?.editable">
            <label class="form-check-label" for="pushAllNodesToOltpRev">
                Push All Nodes to OLTP Reverse Nodes
                <span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.push_all_nodes_to_oltp_rev?.tooltip"
                    data-bs-toggle="tooltip" data-bs-placement="right"></span>
            </label>
        </div>
        <div class="config-row mt-3">
            <div class="config-field">
                <div class="d-flex justify-content-between align-items-center">
                    <label class="form-label fw-bold pt-1">
                        Cluster OLTP Nodes
                        <span class="fa fa-circle-info text-muted ms-1"
                            :title="fieldInfo?.cluster_oltp_nodes?.tooltip" data-bs-toggle="tooltip"
                            data-bs-placement="right"></span>
                    </label>
                    <div class="pb-1">
                        <button v-if="fieldInfo?.cluster_oltp_nodes?.editable" type="button"
                            class="btn btn-sm btn-secondary" @click="resetToInitial('cluster_oltp_nodes')">
                            <i class="fa fa-rotate-left"></i> Reset
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div v-if="config.cluster_oltp_nodes.length > 0">
                            <div v-for="(item, index) in config.cluster_oltp_nodes" :key="index" class="mb-2">
                                <div class="input-group mb-1">
                                    <input type="text" class="form-control" :value="item" style="flex: 3;"
                                        @input="updateArrayItem('cluster_oltp_nodes', index, $event.target.value); updateConfig()"
                                        :disabled="!fieldInfo?.cluster_oltp_nodes?.editable" placeholder="Node ID" />
                                    <button v-if="fieldInfo?.cluster_oltp_nodes?.editable" type="button"
                                        class="btn btn-sm btn-outline-danger"
                                        @click="removeArrayItem('cluster_oltp_nodes', index); updateConfig()">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p class="text-muted">No data found!</p>
                        </div>
                        <div class="d-flex justify-content-end align-items-center">
                            <div>
                                <button v-if="fieldInfo?.cluster_oltp_nodes?.editable" type="button"
                                    class="btn btn-sm btn-primary mt-2 btn-primary"
                                    @click="addArrayItem('cluster_oltp_nodes'); updateConfig()">
                                    <i class="fa fa-plus"></i> Add Entry
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="config-field">
                <div class="d-flex justify-content-between align-items-center">
                    <label class="form-label fw-bold pt-1">
                        OLAP Reverse Cluster Nodes
                        <span class="fa fa-circle-info text-muted ms-1"
                            :title="fieldInfo?.olap_reverse_cluster_nodes?.tooltip" data-bs-toggle="tooltip"
                            data-bs-placement="right"></span>
                    </label>
                    <div class="pb-1">
                        <button v-if="fieldInfo?.olap_reverse_cluster_nodes?.editable" type="button"
                            class="btn btn-sm btn-secondary" @click="resetToInitial('olap_reverse_cluster_nodes')">
                            <i class="fa fa-rotate-left"></i> Reset
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div v-if="config.olap_reverse_cluster_nodes.length > 0">
                            <div v-for="(item, index) in config.olap_reverse_cluster_nodes" :key="index" class="mb-2">
                                <div class="input-group mb-1">
                                    <input type="text" class="form-control" :value="item" style="flex: 3;"
                                        @input="updateArrayItem('olap_reverse_cluster_nodes', index, $event.target.value); updateConfig()"
                                        :disabled="!fieldInfo?.olap_reverse_cluster_nodes?.editable" placeholder="Node ID" />
                                    <button v-if="fieldInfo?.olap_reverse_cluster_nodes?.editable" type="button"
                                        class="btn btn-sm btn-outline-danger"
                                        @click="removeArrayItem('olap_reverse_cluster_nodes', index); updateConfig()">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p class="text-muted">No data found!</p>
                        </div>
                        <div class="d-flex justify-content-end align-items-center">
                            <div>
                                <button v-if="fieldInfo?.olap_reverse_cluster_nodes?.editable" type="button"
                                    class="btn btn-sm btn-primary mt-2 btn-primary"
                                    @click="addArrayItem('olap_reverse_cluster_nodes'); updateConfig()">
                                    <i class="fa fa-plus"></i> Add Entry
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OltpConfigEasyMode',
    data() {
        return {
            config: {
				push_all_nodes_to_oltp: false,
				push_all_nodes_to_oltp_rev: false,
				olap_reverse_cluster_nodes: [],
				cluster_oltp_nodes: [],
			},
			isLoadingFromParent: false,
        }
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({})
        },
        fieldInfo: {
            type: Object,
            default: () => ({})
        },
        cleanConfigFn: {
            type: Function,
            required: true
        },
    },
    watch: {
        modelValue: {
            handler(newVal, oldVal) {
                // Only load config if it's actually different (not just a reference change)
				// This prevents overwriting local changes when switching tabs
				if (newVal && typeof newVal === 'object' && Object.keys(newVal).length > 0) {
					// Check if the config has actually changed by comparing key values
					if (!oldVal || !this.isConfigEqual(newVal, oldVal)) {
						this.isLoadingFromParent = true;
						this.loadConfig(newVal);
						this.$nextTick(() => {
							this.isLoadingFromParent = false;
						});
					}
				}
            },
            deep: true,
            immediate: false
        }
    },
    beforeMount() {
        if (this.modelValue && typeof this.modelValue === 'object' && Object.keys(this.modelValue).length > 0) {
            this.loadConfig(this.modelValue);
        }
    },
    methods: {
        isConfigEqual(config1, config2) {
			// Deep comparison to check if configs are actually different
			if (!config1 || !config2) return false;
			const keys1 = Object.keys(config1);
			const keys2 = Object.keys(config2);
			if (keys1.length !== keys2.length) return false;

			for (let key of keys1) {
				if (JSON.stringify(config1[key]) !== JSON.stringify(config2[key])) {
					return false;
				}
			}
			return true;
		},
        updateConfig() {
            // Emit updated config to parent to maintain state
            // Don't emit if we're currently loading from parent (prevents infinite loop)
            if (!this.isLoadingFromParent) {
				this.$nextTick(() => {
					const configObj = this.cleanConfigFn(this.config);
					this.$emit('update:modelValue', configObj);
				});
			}
        },
        loadConfig(value) {
            if (!value || typeof value !== 'object') {
				return;
			}

            // Initialize config with prop values or defaults
            this.config = {
                push_all_nodes_to_oltp: value.push_all_nodes_to_oltp || false,
                push_all_nodes_to_oltp_rev: value.push_all_nodes_to_oltp_rev || false,
                olap_reverse_cluster_nodes: value.olap_reverse_cluster_nodes || [],
                cluster_oltp_nodes: value.cluster_oltp_nodes || [],
            };
        },
        resetToInitial(fieldName) {
            let config = JSON.parse(JSON.stringify(this.modelValue));
            config[fieldName] = JSON.parse(JSON.stringify(this.fieldInfo[fieldName].initialValue));
            this.loadConfig(config);
            this.updateConfig();
        },
        setPushAllNodesToOltp() {
            this.config.push_all_nodes_to_oltp = !this.config.push_all_nodes_to_oltp;
        },
        setPushAllNodesToOltpRev() {
            this.config.push_all_nodes_to_oltp_rev = !this.config.push_all_nodes_to_oltp_rev;
        },
        addArrayItem(fieldName) {
            this.config[fieldName].push("");
            this.updateConfig();
        },
        updateArrayItem(fieldName, index, value) {
            this.config[fieldName][index] = value;
            this.updateConfig();
        },
        removeArrayItem(fieldName, index) {
            this.config[fieldName].splice(index, 1);
            this.updateConfig();
        },
    }
}
</script>

<style scoped>
.config-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    align-items: flex-start;
}

.config-field {
    flex: 1 1 calc(50% - 0.5rem); 
    min-width: 300px;
    padding: 0.7rem;
    background-color: #fafafa;
    border-radius: 4px;
    box-sizing: border-box;
    box-shadow: 4px 4px 4px rgb(234, 234, 234);
}

@media (max-width: 768px) {
    .config-field {
        flex: 1 1 100%;
    }
}

.input-group {
	display: flex;
	align-items: stretch;
}

.input-group .form-control {
	flex: 1;
}

.form-label {
	font-size: 0.75rem;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.form-select {
	max-width: 100px;
	background-color: #f6f6f6;
}

.card {
	margin-bottom: 0rem;
}
</style>